import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { Contractor } from '../contractor';

import { ContractorService } from '../contractor.service';
import { ContractorTypeService } from '../../contractor_types/contractor-type.service';
import { CountryService } from '../../countries/country.service';
import { CityService } from '../../cities/city.service';
import { CurrencyService } from '../../currencies/currency.service';
import { StoreService } from '../../stores/store.service';
import { GlobalDataService } from '../../../../services/global-data.service';
import { OwnershipTypeService } from '../../ownership_types/ownership-type.service';
import { TarifNameService } from '../../tarifs/tarif-name.service';

import { Router } from '@angular/router';
import { CheckboxModule } from 'primeng/primeng';
import { FileUploadModule } from 'primeng/primeng';
import { Location } from '@angular/common';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';

@Component({
    selector: 'app-contractor-crud',
    templateUrl: './contractor-crud.component.html',
    styleUrls: ['./contractor-crud.component.css'],
    providers: [
        ContractorService,
        ContractorTypeService,
        CountryService,
        CityService,
        CurrencyService,
        StoreService,
        OwnershipTypeService,
        TarifNameService
    ]
})
export class ContractorCrudComponent implements OnInit {


    _defaultLabel: string="Выберите хранилищ...";
    _disabled: boolean = false;
    _store_id: any;
    _store_name: any;
    button_caption: string = "Сохранить"
    button_icon: string = "fa fa-save";
    contractor: Contractor;
    contractorForm: FormGroup;
    id: any = null;
    msgs: Message[] = [];
    selectedContractorType: string;
    selectedParent: string;
    selectedOwnershipType: string;
    selectedCity: string;
    selectedTarif: string;
    selectedCurrency: string;
    selectedStore: string[];
    loading: boolean = false;
    title: string = "";


    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private contractorService: ContractorService,
        private contractorTypeService: ContractorTypeService,
        private countryService: CountryService,
        private cityService: CityService,
        private currencyService: CurrencyService,
        private storeService: StoreService,
        private global: GlobalDataService,
        private ownershipTypeService: OwnershipTypeService,
        private tarifNameService: TarifNameService,
        private location: Location
    ) {

        activatedRoute.params.subscribe(params => { this.id = params['id'] });

        this.contractorForm = new FormGroup({
            name: new FormControl('', [Validators.required, Validators.minLength(2)]),
            parent_id: new FormControl('1'),
            ownership_type_id: new FormControl('', [Validators.required]),
            contractor_type_id: new FormControl('', [Validators.required]),
            city_id: new FormControl(),
            contacts: new FormGroup({
                email: new FormControl(''),
                mobile: new FormControl(''),
                phone: new FormControl(''),
                fax: new FormControl(''),
                sait: new FormControl(''),
                address: new FormControl(''),
            }),
            contracts: new FormGroup({
                number: new FormControl(''),
                name: new FormControl(''),
                description: new FormControl(''),
                created_at: new FormControl(''),
            }),
            tariff_name_id: new FormControl('', [Validators.required]),
            currency_id: new FormControl('ae70ec6e-5816-46f0-95ab-86d7864bc49d'),
            store_id: new FormControl('', [Validators.required]),
            is_has_storage: new FormControl(0),
            limit_balance: new FormControl(0),
            available: new FormControl()
        });


        this.contractor = {
            available: true,
            contractor_types: [],
            contractors: [],
            cities: [],
            currencies: [],
            contacts: { address: "", email: "", fax: "", mobile: "", phone: "", sait: "" },
            contracts: { number: "", name: "", description: "", created_at: "" },
            id: "",
            name: "",
            ownership_types: [],
            stores: "",
            tarif_names: [],
            limit_balance: 0
        }


        if (this.id) {
            this.loading = true;

            this.contractorService.getContractorById(this.id).subscribe(response => {

                this.contractorTypeService.getContractorTypeList().subscribe(response => {
                    this.contractor.contractor_types = response['data'].map(function (value: any) {
                        return { label: value.name, value: value.id };
                    });
                })
                this.contractorService.getContractor().subscribe(response => {
                    this.contractor.contractors = response['data'].map(function (value: any) {
                        return { label: value.name, value: value.id };
                    }); this.loading = false;
                });
                this.ownershipTypeService.getOwnershipType(1).subscribe(response => {
                    this.contractor.ownership_types = response['data'].map(function (value: any) {
                        return { label: value.name, value: value.id };
                    });
                });

                // this.countryService.getCountryList().subscribe(response => {
                //     this.contractor.countries = response['data'].map(function (value: any) {
                //         return { label: value.name, value: value.id };
                //     });
                // });


                this.cityService.getCity(1).subscribe(response => {
                    this.contractor.cities = response['data'].map(function (value: any) {
                        return { label: value.name, value: value.id };
                    });
                });

                this.tarifNameService.getTarifName(1).subscribe(response => {
                    this.contractor.tarif_names = response['data'].map(function (value: any) {
                        return { label: value.name, value: value.id };
                    });
                });
                
                this.contractor.stores = this.global.user.stores.map(function(value){return {label: value.name, value: value.id }});
                // this.storeService.getStore().subscribe(response=>{
                //     this.contractor.stores=response['data'].map(function(value: any){
                //          return {label:value.name, value: value.id};
                //      });
                // })         
                // console.log(this.global.user.stores);
               
                

               
               
                // this.currencyService.getCurrency().subscribe(response => {
                //     this.contractor.currencies = response['data'].map(function (value: any) {
                //         return { label: value.name, value: value.id };
                //     });
                // });

                // this.selectedCurrency = response['data'].currency && response['data'].currency.id;
                this.selectedTarif = response['data'].tariff_name && response['data'].tariff_name.id;
                this.selectedParent = response['data'].parent && response['data'].parent.id
                this.selectedOwnershipType = response['data'].ownership_type && response['data'].ownership_type.id
                this.selectedContractorType = response['data'].contractor_type && response['data'].contractor_type.id;
                this.selectedCity = response['data'].city && response['data'].city.id;
                this.selectedStore = response['data'].store && response['data'].store.id;
                this.contractor = response['data'];

            });
            this.title = "Редактирование компании";
            this.button_caption = "Редактировать";
            this.button_icon = "fa fa-edit";
        } else {
            this.title = "Добавление компании";
            this.contractorService.getContractor().subscribe(response => {
                this.contractor.contractors = response['data'].map(function (value: any) {
                    return { label: value.name, value: value.id };
                });
            });
            this.ownershipTypeService.getOwnershipType(1).subscribe(response => {
                this.contractor.ownership_types = response['data'].map(function (value: any) {
                    return { label: value.name, value: value.id };
                });
            });
            this.contractorTypeService.getContractorTypeList().subscribe(response => {
                this.contractor.contractor_types = response['data'].map(function (value: any) {
                    return { label: value.name, value: value.id };
                });
            });

           

            // this.countryService.getCountryList().subscribe(response => {
            //     this.contractor.countries = response['data'].map(function (value: any) {
            //         return { label: value.name, value: value.id };
            //     });
            // });
            
            

            this.cityService.getCity(1).subscribe(response => {
                this.contractor.cities = response['data'].map(function (value: any) {
                    return { label: value.name, value: value.id };
                });
            });

            this.tarifNameService.getTarifName(1).subscribe(response => {
                this.contractor.tarif_names = response['data'].map(function (value: any) {
                    return { label: value.name, value: value.id };
                });

            });
            
            // console.log(this.global.user.stores);
            this.contractor.stores = this.global.user.stores.map(function(value){return {label: value.name, value: value.id }});
           

            // this.storeService.getStore().subscribe(response=>{
            //     this.contractor.stores=response['data'].map(function(value: any){
            //          return {label:value.name, value: value.id};
            // }); })
            // this.currencyService.getCurrency().subscribe(response => {
            //     this.contractor.currencies = response['data'].map(function (value: any) {
            //         return { label: value.name, value: value.id };
            //     });
            // });
        }

        this.selectedParent = '1';

    }

    ngOnInit() {

    }
    backClicked() {
        this.location.back();
    }
    crud(form): void {
        if (!this.id) {
            this.loading = true;
            this.contractorService.createContractor(form.value)
                .subscribe((data) => { this.loading = false; this.router.navigate(['/dashboard/contractor']); }
                , (error) => {
                    this.loading = false;
                });

        } else {
            this.loading = true;
            this.contractorService.updateContractor(form.value, this.id)
                .subscribe((data) => { this.loading = false; this.router.navigate(['/dashboard/contractor']); }
                , (error) => {
                    this.loading = false;
                });
        }



    }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contractors/contractor-crud/contractor-crud.component.ts